exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".po-allocation-data-container{background-color:#fff;padding:15px;min-height:100px}@media (max-width:1000px){.app-modal{left:0!important;width:100%!important;overflow-y:auto!important}}", ""]);

// exports
